import customer from '../../images/customer.png';
import { StoreContext } from '../Store';
import { useContext, useState, useEffect } from 'react';
import DataTable from '../DataTable';
import { PlusCircle } from '@styled-icons/fa-solid';
import checkmark from '../../images/checkmark.png';
import { useNavigate } from 'react-router-dom';
import ParentsModal from './Modals/ParentsModal';
import { getCustomerList } from '../../api/v2/load';
import { useQueryClient } from '@tanstack/react-query';
import { getBusinessPartnerParent } from '../../api/v2/businessPartner';
import { useBusinessPartner } from './queryHooks/useBusinessPartner';

export default function ClientIdPage({ customaiteEnabled, resetIpaffsOnMount }) {
  const store = useContext(StoreContext);
  const [value, setValue] = useState(null);
  const [showParentsModal, setShowParentsModal] = useState(false);
  const [parents, setParents] = useState([]);
  const [selectedParent, setSelectedParent] = useState(null);
  const navigate = useNavigate();
  const { fetchBusinessPartnerStatus } = useBusinessPartner();

  useEffect(() => {
    if (resetIpaffsOnMount) {
      store.ipaffsCategories[1]({});
      store.certificateCount[1](0);
    }

    const fetch = async () => {
      const data = await getCustomerList();
      store.clientIDoptions[1](data);
    };

    fetch();
  }, [resetIpaffsOnMount]);

  const queryClient = useQueryClient();

  const submit = async () => {
    const data = await fetchBusinessPartnerStatus(value);

    store.clientIdAllowSAonNeeNors[1](data?.allowSAOnNeeNors || false); // CABS-2636: Scenario 5

    // for Build/Import your load, a customer is considered valid on these three conditions:
    const customerIsLoadValid = data.cabieStatusValid && data.dbStatusValid && data.billableCustomerValid;

    if (!customerIsLoadValid) navigate(`/load/customerValidation/${value}`);

    if (data?.BPType == 'PARENT') {
      await store.updateParentAndLoadDefaults({
        parentId: data.id,
        parentName: data.companyName,
      });
      store.clientID[1](value);
    } else {
      const businessPartnerId = data?.id;
      if (businessPartnerId) {
        let parents = await queryClient.fetchQuery({
          queryKey: ['getBusinessPartnerParent', businessPartnerId],
          queryFn: () => getBusinessPartnerParent(businessPartnerId),
        });
        parents = parents.filter((parent) => parent.checked);
        //if parents contains just one item, set newLoadParent parentId = parents[0].ParentTraderId and parentName = parents[0].companyName
        if (parents.length === 1) {
          await store.updateParentAndLoadDefaults({
            parentId: parents[0].ParentTraderId,
            parentName: parents[0].companyName,
            parentEori: parents[0].eori,
          });
          store.clientID[1](value);
          return;
        }
        setParents(parents);
        setShowParentsModal(true);
      } else {
        store.clientID[1](value);
      }
    }
  };

  const handleParentSelect = (parentId) => {
    setSelectedParent(parentId);
  };

  const handleContinue = async () => {
    if (selectedParent) {
      const parent = parents.find((p) => p.ParentTraderId === selectedParent);
      if (parent) {
        await store.updateParentAndLoadDefaults({
          parentId: parent.ParentTraderId,
          parentName: parent.companyName,
          parentEori: parent.eori,
        });
      }
    }
    store.clientID[1](value);
  };

  return (
    <>
      <ParentsModal
        showModal={showParentsModal}
        setShowModal={setShowParentsModal}
        onContinue={handleContinue}
        parents={parents}
        selectedParent={selectedParent}
        onParentSelect={handleParentSelect}
        value={value}
      />
      <div className="semi-fluid-container container-xl file-upload" style={{ maxWidth: '950px' }}>
        <div className="floating-box-newload">
          <div className="d-flex flex-column py-4 px-5">
            <h2 className="epo-steps-header">
              {customaiteEnabled ? 'Select a Business Partner' : 'Select a Customer'}
            </h2>

            <div className="step-banner with-img" style={{ minHeight: '0' }}>
              <img src={customer} width="70" height="70" alt="port" />
              <p>Please select the customer from the list below you wish to link to this new load</p>
            </div>
            <div className="d-flex flex-column justify-content-md-start py-1 ">
              <DataTable
                dontRefreshPagination
                sortable
                filterable
                data={(store.clientIDoptions[0] ?? []).map((item, idx) => ({
                  ...item,
                  __rowKey: `${item.id ?? 'item'}-${idx}`,
                }))}
                className="table-bordered"
                idKey="__rowKey"
              >
                <DataTable.Pagination itemsPerPage={[5, 10, 20]} />
                <DataTable.Headers style={{ fontSize: '11px' }} />
                <DataTable.Row
                  className={(item) => {
                    if (item.id === value) {
                      return 'clientID-selected-row';
                    }
                    return '';
                  }}
                  style={{ fontSize: '16px' }}
                />
                <DataTable.Column colKey="companyName" header="Companies" />
                <DataTable.Column colKey="eori" header="EORI" />
                <DataTable.Column
                  header="Select"
                  style={{ height: '1px', padding: 0 }}
                  headerStyle={{ textAlign: 'center' }}
                >
                  {(query) => (
                    <button
                      className="external-table-link"
                      onClick={() => {
                        setValue(query.id);
                      }}
                    >
                      {query.id !== value ? (
                        <PlusCircle width="1.1rem" height="1.1rem" />
                      ) : (
                        <img src={checkmark} width="20px" alt="check" />
                      )}
                    </button>
                  )}
                </DataTable.Column>
              </DataTable>
            </div>
            <section className="d-flex justify-content-end mt-2">
              <button type="button" className="blue-button-teams" disabled={!value} onClick={submit}>
                Continue
              </button>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
